function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" fill="none" viewBox="0 0 36 36">
      <path
        fill="#000"
        d="M18 10.333a1 1 0 011 1V17h5.667a1 1 0 110 2H19v5.667a1 1 0 01-2 0V19h-5.666a1 1 0 110-2H17v-5.667a1 1 0 011-1z"
      ></path>
      <path
        fill="#000"
        fillRule="evenodd"
        d="M.333 18C.333 8.243 8.243.333 18 .333c9.757 0 17.667 7.91 17.667 17.667 0 9.757-7.91 17.667-17.667 17.667C8.243 35.667.333 27.757.333 18zM18 2.333C9.348 2.333 2.334 9.347 2.334 18c0 8.652 7.014 15.667 15.666 15.667 8.653 0 15.667-7.015 15.667-15.667 0-8.653-7.014-15.667-15.667-15.667z"
        clipRule="evenodd"
      ></path>
    </svg>
  );
}

export default Icon;
